// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as LifeBuoyBDefault } from '../../../assets/icons/default/general/life-buoy-b.svg?react';
import { ReactComponent as LifeBuoyBSolid } from '../../../assets/icons/solid/general/LIFE-BUOY-B.svg?react';
import { createIcons } from '../../Icon';
const LifeBuoyBIcon = /* @__PURE__ */ createIcons('LifeBuoyB', {
    default: LifeBuoyBDefault,
    solid: LifeBuoyBSolid
});
LifeBuoyBIcon.supportedTypes = ['default', 'solid'];
LifeBuoyBIcon.category = 'general';
export default LifeBuoyBIcon;
